(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Fade-up / highlight reveal on scroll ---
  // [data-reveal]: opacity+position fade (cards, images, floating groups)
  // .ab__body p: dim-to-full-colour "highlight" reveal, one paragraph at a
  // time, for long-form copy like the About Us page.
  var revealEls = document.querySelectorAll('[data-reveal], .ab__body p');

  if (reduceMotion) {
    revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
    document.querySelectorAll('[data-scrub-text] .word').forEach(function (el) {
      el.classList.add('is-lit');
    });
    return;
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  // --- Smooth (eased) vertical parallax drift on images ---
  var parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]')).map(function (wrapper) {
    return {
      el: wrapper.querySelector('[data-parallax-img]') || wrapper,
      ref: wrapper,
      speed: parseFloat(wrapper.getAttribute('data-parallax')) || 18,
      current: 0,
      target: 0,
      axis: 'y',
      scale: true,
    };
  });

  // --- Smooth (eased) horizontal parallax drift — text moving away from /
  // toward a center point (e.g. an image) as you scroll, like aseyie.com ---
  var parallaxXEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-x]')).map(function (el) {
    return {
      el: el,
      ref: el,
      speed: parseFloat(el.getAttribute('data-parallax-x')) || 0,
      current: 0,
      target: 0,
      axis: 'x',
      scale: false,
    };
  });

  var items = parallaxEls.concat(parallaxXEls);

  // --- Scroll-scrubbed text reveal — words darken progressively in sync
  // with scroll position (not a one-time trigger), like aseyie.com/pages/discover ---
  var scrubEls = Array.prototype.slice.call(document.querySelectorAll('[data-scrub-text]')).map(function (el) {
    return {
      ref: el,
      words: Array.prototype.slice.call(el.querySelectorAll('.word')),
      lastLit: -1,
    };
  });

  if (!items.length && !scrubEls.length) return;

  var vh = window.innerHeight;
  window.addEventListener('resize', function () { vh = window.innerHeight; });

  function computeTargets() {
    items.forEach(function (item) {
      var rect = item.ref.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return; // skip far-offscreen work
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      item.target = progress * item.speed * -1;
    });
  }

  function updateScrubText() {
    scrubEls.forEach(function (item) {
      if (!item.words.length) return;
      var rect = item.ref.getBoundingClientRect();
      // Reveal window: starts as the block enters the bottom of the viewport,
      // finishes once it's scrolled up to ~35% from the top.
      var scrubStart = vh;
      var scrubEnd = vh * 0.35;
      var progress = (scrubStart - rect.top) / (scrubStart - scrubEnd);
      progress = Math.max(0, Math.min(1, progress));
      var litCount = Math.round(progress * item.words.length);
      if (litCount === item.lastLit) return;
      item.lastLit = litCount;
      item.words.forEach(function (word, i) {
        word.classList.toggle('is-lit', i < litCount);
      });
    });
  }

  function tick() {
    computeTargets();
    items.forEach(function (item) {
      // Ease the visual position toward the target — this is what makes the
      // motion feel fluid/smooth rather than snapping 1:1 with scroll position.
      item.current += (item.target - item.current) * 0.08;
      if (Math.abs(item.target - item.current) < 0.01) item.current = item.target;
      var translate = item.axis === 'x'
        ? 'translate3d(' + item.current.toFixed(2) + 'px,0,0)'
        : 'translate3d(0,' + item.current.toFixed(2) + 'px,0)';
      item.el.style.transform = item.scale ? translate + ' scale(1.1)' : translate;
    });
    updateScrubText();
    requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
})();
